var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoanIconPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b17452d8-9c80-4210-b5c6-4dbe97761dd0{fill:#17171c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "acd49616-ac26-418c-9f9f-fe6ed379ac42",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b17452d8-9c80-4210-b5c6-4dbe97761dd0",
    d: "M170.83,85.84H114.16V22.08a14.17,14.17,0,0,0-28.33,0V85.84H29.17a14.17,14.17,0,1,0,0,28.33H85.83v63.75a14.17,14.17,0,0,0,28.33,0V114.17h56.67a14.17,14.17,0,1,0,0-28.33Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanIconPlus);
export default __webpack_public_path__ + "static/media/LoanIcon_plus.4105955f50c264da61b7b6a7d40eff59.svg";
export { ForwardRef as ReactComponent };